(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('bh-announcement-rotator')) {
    class BhAnnouncementRotator extends HTMLElement {
      constructor() {
        super();
        this.timer = null;
        this.hovering = false;
        this.focusing = false;
        this.editorHold = false;
        this.listening = false;
        this.onVisibility = () => this.schedule();
        this.onBlockSelect = (event) => this.handleBlockSelect(event);
        this.onBlockDeselect = (event) => {
          if (this.contains(event.target)) {
            this.editorHold = false;
            this.schedule();
          }
        };
      }

      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.bh-annc__item'));
        if (this.items.length < 2) return;

        const seconds = parseFloat(this.dataset.interval);
        this.delay = Math.max(6, isNaN(seconds) ? 7 : seconds) * 1000;
        const active = this.items.findIndex((item) => item.classList.contains('is-active'));
        this.index = active < 0 ? 0 : active;

        if (!this.listening) {
          this.listening = true;
          // Mouse only: a tap on a touch screen must not freeze the rotation
          this.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') { this.hovering = true; this.schedule(); }
          });
          this.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') { this.hovering = false; this.schedule(); }
          });
          this.addEventListener('focusin', () => { this.focusing = true; this.schedule(); });
          this.addEventListener('focusout', (event) => {
            this.focusing = this.contains(event.relatedTarget);
            this.schedule();
          });
        }

        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.render();
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.items || this.items.length < 2) return;
        // Auto-rotating content stays silent; while paused by hover or focus it may be announced politely
        this.setAttribute('aria-live', this.hovering || this.focusing ? 'polite' : 'off');
        if (this.hovering || this.focusing || this.editorHold || document.hidden) return;
        this.timer = setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, this.delay);
      }

      show(next) {
        const count = this.items.length;
        const target = ((next % count) + count) % count;
        if (target === this.index) return;
        const leaving = this.items[this.index];
        leaving.classList.add('is-leaving');
        clearTimeout(leaving.bhLeaveTimer);
        leaving.bhLeaveTimer = setTimeout(() => leaving.classList.remove('is-leaving'), 900);
        this.items[target].classList.remove('is-leaving');
        this.index = target;
        this.render();
      }

      render() {
        this.items.forEach((item, position) => {
          const isActive = position === this.index;
          item.classList.toggle('is-active', isActive);
          if (isActive) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
          if ('inert' in item) item.inert = !isActive;
          item.querySelectorAll('a').forEach((link) => {
            if (isActive) {
              link.removeAttribute('tabindex');
            } else {
              link.setAttribute('tabindex', '-1');
            }
          });
        });
      }

      handleBlockSelect(event) {
        if (!this.items || !this.contains(event.target)) return;
        const position = this.items.findIndex((item) => item === event.target || item.contains(event.target));
        if (position < 0) return;
        this.editorHold = true;
        this.show(position);
        this.schedule();
      }
    }

    customElements.define('bh-announcement-rotator', BhAnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
